import { render, staticRenderFns } from "./AppFooterBlack.vue?vue&type=template&id=5b32326a&scoped=true&"
import script from "./AppFooterBlack.vue?vue&type=script&lang=js&"
export * from "./AppFooterBlack.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterBlack.vue?vue&type=style&index=0&id=5b32326a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32326a",
  null
  
)

export default component.exports